module.exports = __webpack_public_path__ + "b8c72d441cd985c49813d0a381b1d999.pdf";